import { CoreIcon } from '../core-icon';
import linkCircleSVG from '../../assets/icons/link-circle.svg';
import type { IconProps } from '../core-icon';

export const LinkCircleIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={linkCircleSVG} {...props} />;
};
